(function () {
    pagination(true);
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function checkCookie() {
    if (document.cookie.indexOf("cookie-consent=accepted") === -1) {
        document.getElementById("cookie-consent").style.display = "block";
    }
}

(function () {
    document.getElementById("accept-cookies").addEventListener("click", function () {
        // Set the cookie and hide the banner when the user accepts
        setCookie("cookie-consent", "accepted", 365);
        document.getElementById("cookie-consent").style.display = "none";
    });

    window.addEventListener("load", checkCookie);
})();

